module.exports = __webpack_public_path__ + "media/assets/illustrations/calendar-f71ac7a43855cb0e8b049ce7d7240ce9.svg";